(function($) {

    $.fn.msxiSpinner = function(options) {
        // build main options before element iteration
        var opts = $.extend( {}, $.fn.msxiSpinner.defaults, options);

        return this.each(function() {
            var $this = $(this);
            // build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            var spinnerOpts = eOpts['spinner'];

            if($this.is(':disabled') || $this.is('[readonly]')) {
                spinnerOpts = $.extend(spinnerOpts, {disabled: true});
            }

            $this.spinner(spinnerOpts);

            $this.on('disabled', function(){
                $this.spinner('disable');
            });

            $this.on('enabled', function(){
                $this.spinner('enable');
            });

            if ($this.hasClass("form-number-range-right")) {
                updateMinAndMax($this, $this.val());
            }
        });
    };

    //
    // plugin defaults
    //
    $.fn.msxiSpinner.defaults = {
        spinner: {
            change: function(e){
                var $spinner = $(e.target);
                var val = $spinner.val();
                updateMinAndMax($spinner, val);
                var min = $spinner.spinner( "option", "min" );
                var max = $spinner.spinner( "option", "max" );
                var step = $spinner.spinner( "option", "step" );
                if(min!=null && val < min) {
                    $spinner.val(min);
                }
                if(max!=null && val > max) {
                    $spinner.val(max);
                }
                // multiple value and step by 1/step to remove decimal places and avoid floating point arithmetic errors
                if(step!= null && (val * (1/step)) % (step * (1/step)) != 0) {
                    $spinner.val(val - val % step);
                }

                // reset to empty if input value is not numeric, as it will cause conversion exception when sending the value back to server.
                var newVal = $spinner.val();
                if (!$.isNumeric(newVal))
                {
                    $spinner.val('');
                }
            }
        }
    };

    function updateMinAndMax($spinner, val) {
        if ($spinner.hasClass("form-number-range-left") || $spinner.hasClass("form-number-range-right")) {
            var $parent = $spinner.closest(".form-number-range");
            if ($parent.length > 0) {
                if ($spinner.hasClass("form-number-range-left")) {
                    var $right = $parent.find(".form-number-range-right");
                    $right.spinner("option", "min", val);
                }
                if ($spinner.hasClass("form-number-range-right")) {
                    var $left = $parent.find(".form-number-range-left");
                    $left.spinner("option", "max", val);
                    // The left spinner will have been inited before the right one, so call update on left spinner to set min on right one
                    updateMinAndMax($left, $left.val());
                }
            }
        }
    }

})(jQuery);